import LoginMain from "./LoginMain";
import OTPLoginMain from './OTPLoginMain';
//import {MFALoginMain} from './MFALoginMain';
import MFALoginMain from './MFALoginMain';

export {OTPLoginMain};
//export {MFALoginMain} from './MFALoginMain';
//export MFALoginMain from './MFALoginMain';
export default MFALoginMain;